import { useTranslation } from "react-i18next";
import type { AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import { GenericAnalyticsTab } from "@/features/admin/components/analytics/GenericAnalyticsTab";

export function ContentGenresAnalyticsTab({ loading, snapshot }: { loading?: boolean; snapshot: AnalyticsSnapshotResponse | null }) {
  const { t } = useTranslation();
  return (
    <GenericAnalyticsTab
      loading={loading}
      panels={[
        { chart: "line", metricKey: "new_chapters", series: ["total"], title: t("adminWorkspace.analytics.content.chapters") },
        { chart: "line", metricKey: "new_entity_cards", series: ["total"], title: t("adminWorkspace.analytics.content.entities") },
        { chart: "line", metricKey: "new_lore_entries", series: ["total"], title: t("adminWorkspace.analytics.content.lore") },
        { chart: "bar", metricKey: "exports_completed_by_format", series: ["pdf", "docx", "epub", "md", "unknown"], title: t("adminWorkspace.analytics.content.exports") },
        { chart: "bar", metricKey: "import_jobs_completed", series: ["total"], title: t("adminWorkspace.analytics.content.imports") },
      ]}
      snapshot={snapshot}
    />
  );
}
